import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  { path: '', redirectTo: 'redirect', pathMatch: 'full' },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./layout/layout.module').then(
            (module: typeof import('./layout/layout.module')) => module.LayoutModule
          ),
      },
    ],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./modules/onboarding/onboarding.module').then(
        (module: typeof import('./modules/onboarding/onboarding.module')) =>
          module.OnboardingModule
      ),
  },
  {
    path: 'redirect',
    loadChildren: () =>
      import('./modules/redirect/redirect.module').then(
        (module: typeof import('./modules/redirect/redirect.module')) =>
          module.RedirectModule
      ),
  },
  { path: '**', redirectTo: 'redirect', pathMatch: 'full' },
];

const config: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'disabled',
};

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, config)],
})
class AppRoutingModule {}

export { AppRoutingModule };
